/*
 * Production days, the same everywhere on the web.
 *
 * PPDays.sort / PPDays.byDate: always in date order, days without a date last, the same date (two units
 * that day) in their saved order. The API orders the same way (byDayDate in packages/legacy, DAY_ORDER in
 * apps/api/src/lib/day-order.ts); sorting again here keeps lists that join or regroup days in order too.
 *
 * PPDays.chips / PPDays.pick / PPDays.only: a row of day-type chips (All, Shoot, Scout, …) over a long
 * list of days. The choice is kept per project on this device and shared by every list that shows it.
 * Types are Locations' (day_kinds), named by the board's day_types (apps/api/src/lib/day-types.ts).
 */
(function () {
  var ORDER = ['shoot', 'scout', 'prep', 'rehearsal', 'travel', 'strike'];
  var SHORT = { shoot: 'Shoot', scout: 'Scout', prep: 'Pre-light', rehearsal: 'Rehearsal', travel: 'Travel', strike: 'Strike' };
  var KEY = 'pp-day-type:';

  function dateOf(d) { return String((d && d.date) || '').trim(); }
  function byDate(a, b) {
    var x = dateOf(a), y = dateOf(b);
    if (!x !== !y) return x ? -1 : 1;
    if (x !== y) return x < y ? -1 : 1;
    var s = a && a.sort, t = b && b.sort;
    return typeof s === 'number' && typeof t === 'number' ? s - t : 0;
  }
  function sort(days) { return (days || []).slice().sort(byDate); }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function kindIn(kindOf, d) { var k = typeof kindOf === 'function' ? kindOf(d) : d && d.kind; return SHORT[k] ? k : 'shoot'; }

  function name(kind, types) { var t = types && types[kind]; return (t && t.short) || SHORT[kind] || ''; }
  function pick(project) { try { return localStorage.getItem(KEY + project) || ''; } catch (e) { return ''; } }
  function choose(project, kind) {
    try { if (kind) localStorage.setItem(KEY + project, kind); else localStorage.removeItem(KEY + project); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('pp-day-type', { detail: { project: project, kind: kind || '' } })); } catch (e) {}
  }
  // The types these days have, in the order they're offered.
  function kinds(days, kindOf) {
    var seen = {};
    (days || []).forEach(function (d) { var k = kindIn(kindOf, d); seen[k] = (seen[k] || 0) + 1; });
    return ORDER.filter(function (k) { return seen[k]; }).map(function (k) { return { kind: k, count: seen[k] }; });
  }
  // The type in force: the saved one while these days have it, else All ('').
  function current(project, days, kindOf) {
    var k = pick(project);
    return k && kinds(days, kindOf).some(function (x) { return x.kind === k; }) ? k : '';
  }
  // The days to list: those of the chosen type, plus `keep` (the open day) so it never vanishes.
  function only(project, days, kindOf, keep) {
    var k = current(project, days, kindOf);
    return k ? (days || []).filter(function (d) { return kindIn(kindOf, d) === k || (keep && d && d.id === keep); }) : (days || []);
  }
  // The chips, or '' when every day is the same type. Clicks: [data-day-type] → PPDays.choose(project, kind).
  function chips(project, days, kindOf, types) {
    var list = kinds(days, kindOf);
    if (list.length < 2) return '';
    var k = current(project, days, kindOf);
    return '<div class="ppl-chips pp-day-chips" role="group" aria-label="Day type">'
      + '<button type="button" class="ppl-chip" data-day-type="" aria-pressed="' + (!k) + '">All days<span>' + (days || []).length + '</span></button>'
      + list.map(function (x) { return '<button type="button" class="ppl-chip" data-day-type="' + x.kind + '" aria-pressed="' + (k === x.kind) + '">' + esc(name(x.kind, types)) + '<span>' + x.count + '</span></button>'; }).join('')
      + '</div>';
  }

  window.PPDays = { byDate: byDate, sort: sort, kinds: kinds, name: name, pick: pick, choose: choose, current: current, only: only, chips: chips };
})();
